import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Play, TrendingUp, TrendingDown } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function PresetsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/preset-strategies")
      .then((r) => setItems(r.data.items || []))
      .catch(() => toast.error("Stratejiler yüklenemedi"))
      .finally(() => setLoading(false));
  }, []);

  const run = (item) => {
    sessionStorage.setItem("ztan_preset", JSON.stringify({ universe: item.universe, filters: item.filters, autorun: true }));
    nav("/");
  };

  return (
    <div className="space-y-6" data-testid="presets-page">
      <div>
        <h1 className="text-2xl font-semibold text-text-primary ztan-title flex items-center gap-2">
          <Sparkles size={22} className="text-accent-yellow" /> Hazır Stratejiler
        </h1>
        <p className="text-sm text-text-secondary mt-1">Uzman kürasyonlu tarama filtreleri — tek tıkla çalıştırın</p>
      </div>

      {loading ? (
        <div className="p-16 flex justify-center"><div className="radar-loader" /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => {
            const Icon = it.tone === "up" ? TrendingUp : TrendingDown;
            const toneColor = it.tone === "up" ? "text-signal-up" : "text-signal-down";
            const toneBg = it.tone === "up" ? "bg-signal-up/10 border-signal-up/30" : "bg-signal-down/10 border-signal-down/30";
            return (
              <div
                key={it.id}
                data-testid={`preset-card-${it.id}`}
                className="bg-bg-panel border border-bg-border hover:border-brand-blue/60 rounded-xl p-5 flex flex-col transition-all group"
              >
                <div className={`w-10 h-10 rounded-lg border ${toneBg} flex items-center justify-center mb-3`}>
                  <Icon size={18} className={toneColor} />
                </div>
                <h3 className="text-base font-semibold text-text-primary group-hover:text-brand-blueLight transition-colors">
                  {it.name}
                </h3>
                <p className="text-xs text-text-secondary mt-1 mb-4 leading-relaxed flex-1">{it.description}</p>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="text-[10px] px-2 py-0.5 rounded border border-bg-border text-text-secondary bg-bg-base uppercase tracking-wider">
                    {it.universe.replace("_", " ")}
                  </span>
                  <span className="text-[10px] px-2 py-0.5 rounded border border-bg-border text-text-secondary bg-bg-base">
                    {it.filters.length} kriter
                  </span>
                </div>
                <button
                  data-testid={`preset-run-${it.id}`}
                  onClick={() => run(it)}
                  className="bg-accent-yellow text-bg-base font-semibold text-xs py-2 px-3 rounded-lg w-full flex items-center justify-center gap-1.5 hover:opacity-90 active:scale-[0.99] transition-all"
                >
                  <Play size={12} /> Bu Stratejiyi Çalıştır
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
